/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_BoldInputs */

const en_editor_bold = /** @type {(inputs: Editor_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold`)
};

/**
* | output |
* | --- |
* | "Bold" |
*
* @param {Editor_BoldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const editor_bold = /** @type {((inputs?: Editor_BoldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_BoldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_editor_bold(inputs)
});